export default __webpack_public_path__ + "static/media/Litto-4.6f9c8908.png";